// react
import React from "react";

// application
import ProductCard from "../shared/ProductCard";
import BlockProductsCarousel from "./BlockProductsCarousel";
import classNames from "classnames";
import Countdown from "react-countdown";
import moment from "moment";

export default function BlockTrendingProducts(props) {
    const { title, highlightTitle, products, mode, countDownDate } = props;
    const renderer = ({ formatted, completed }) => {
        if (completed) {
            return null;
        } else {
            return (
                <>
                    <i style={{ fontSize: "1.3rem" }} className="far fa-clock pr-2 text-color-theme" />
                    <span style={{ fontSize: "1.3rem" }} className="pr-2">
                        ENDS IN
                    </span>
                    <span>
                        <span className="time-box mr-1">{formatted.hours}</span>
                    </span>
                    <span style={{ fontSize: "1.3rem", color: "lightgrey" }}>:</span>
                    <span>
                        <span className="time-box ml-1 mr-1">{formatted.minutes}</span>
                    </span>
                    <span style={{ fontSize: "1.3rem", color: "lightgrey" }}>:</span>
                    <span>
                        <span className="time-box ml-1">{formatted.seconds}</span>
                    </span>
                </>
            );
        }
    };
    return (
        <div
            className={classNames("px-sm-0 block pt-4 products-view__list products-list", { container: mode !== "carousel" })}
            data-layout={"grid-5-full"}
        >
            <h3 className="section-title">
                <span className="highlight">{highlightTitle}</span> {title}
                {countDownDate ? (
                    <div className="mt-2">
                        <Countdown daysInHours={true} date={moment(countDownDate).toISOString()} zeroPadTime={2} renderer={renderer} />
                    </div>
                ) : null}
            </h3>
            {mode == "carousel" ? (
                <BlockProductsCarousel title="" layout={"grid-5"} products={products} rows={2} />
            ) : (
                <div className="products-list__body">
                    {products.map((product) => {
                        return (
                            <div key={product.uuid} className="products-list__item">
                                <ProductCard product={product} />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
